import type { NotificationItem } from "src/notifications/useNotifications";

/** The i18n key (under `notifications.headline.`) and the part after the dash, per notification. */
export interface NotificationText {
	headline: string;
	values: { actor?: string; solution?: string };
	/** "— Silicon Valley ⇄ AWS us-west-2": what was added, or the solution it happened to. */
	detail?: string;
}

const STATUS_HEADLINES: Record<string, string> = {
	draft: "statusDraft",
	proposed: "statusProposed",
	accepted: "statusAccepted",
	rejected: "statusRejected"
};

/**
 * Figma 2:3968's lines ("**Bo Gavey published a new model** — Silicon Valley ⇄ AWS us-west-2"),
 * from the type and the names stored with the notification. Pure.
 */
export const notificationText = ({ type, data }: Pick<NotificationItem, "type" | "data">): NotificationText => {
	const values = { actor: data.actorName, solution: data.solutionName };
	switch (type) {
		case "model.added":
			return { headline: "modelAdded", values, detail: data.subjectName };
		case "build.added":
			return { headline: "buildAdded", values, detail: data.subjectName };
		case "solution.statusChanged":
			return { headline: STATUS_HEADLINES[data.status ?? ""] ?? "statusChanged", values };
		case "design.updated":
			return { headline: "designUpdated", values, detail: data.solutionName };
	}
};
